import { useState, useEffect } from "react";
import Accordion from "../..//modules/accordion";
import channelPackAccordion from "../../modules/channel-pack-accordion";
import Actions from "../actions/actions";
import ChangeOfPackage from "../changeOfPackage/changeOfPackage";
import AdditionalPackages from "../additionalPackages/additionalPackages";
import UsefulServices from "../usefulServices/usefulServices";
import { cards } from "../../lib/api/api";

const MorePossibilities = ({
  ID,
  cardID,
  selectedPackages,
  setSelectedPackages,
  setPackageToDelete,
  connectedPackages,
  changeMessage,
  promotions,
  services,
}) => {
  const [categories, setCategories] = useState([]);
  const [thematicPackages, setThematicPackages] = useState([]);
  const [usefulServices, setUsefulServices] = useState([]);
  const [actions, setActions] = useState([]);

  useEffect(() => {
    Accordion.init();
    channelPackAccordion();
  }, []);

  useEffect(() => {
    if (ID !== null) {
      cards
        .actions(ID)
        .then((res) => {
          setActions(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [ID]);

  useEffect(() => {
    if (ID !== null && services.length > 0) {
      cards
        .subscriptions(ID)
        .then((res) => {
          const additionalPackages = res.filter((item) => item.type.id !== "1");
          let array = [];
          setThematicPackages([]);
          setUsefulServices([]);
          additionalPackages.forEach((item) => {
            array.push(item.category);
            const element = services.filter(
              (elem) => elem.billing_service_code == item.billing_service_code,
            );
            if (element[0].is_theme)
              setThematicPackages((prevState) => [...prevState, item]);
            if (element[0].is_service)
              setUsefulServices((prevState) => [...prevState, item]);
          });
          const unique = array.reduce((accumulator, current) => {
            if (
              accumulator.findIndex((object) => object.id === current.id) === -1
            ) {
              accumulator.push(current);
            }
            return accumulator;
          }, []);
          setCategories(unique);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [ID, services]);

  return (
    <>
      <div
        className="more-possibilities page__more-possibilities"
        id="all-services"
      >
        <div className="more-possibilities__header">
          <div className="more-possibilities__container page-container">
            <h2 className="more-possibilities__title title title--h2">
              Больше каналов и возможностей
            </h2>
          </div>
        </div>
        <div className="more-possibilities__accordion accordion not-inited">
          <div className="more-possibilities__container page-container">
            <ul className="accordion__list">
              {thematicPackages.length > 0 && (
                <AdditionalPackages
                  subscriptions={thematicPackages}
                  categories={categories}
                  selectedPackages={selectedPackages}
                  setSelectedPackages={setSelectedPackages}
                  setPackageToDelete={setPackageToDelete}
                  connectedPackages={connectedPackages}
                />
              )}
              {actions.length > 0 && (
                <Actions
                  cardID={cardID}
                  changeMessage={changeMessage}
                  actions={actions}
                />
              )}
              {usefulServices.length > 0 && (
                <UsefulServices
                  subscriptions={usefulServices}
                  selectedPackages={selectedPackages}
                  setSelectedPackages={setSelectedPackages}
                  setPackageToDelete={setPackageToDelete}
                  connectedPackages={connectedPackages}
                />
              )}
              <ChangeOfPackage
                ID={ID}
                cardID={cardID}
                changeMessage={changeMessage}
                promotions={promotions}
              />
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default MorePossibilities;
